import React, { Fragment } from "react";

import OutlineButton from "../../../../components/ui/buttons/OutlineButton";
import ProductCard from "../../../../components/ui/productCard/ProductCard";
import useLoadMore from "../../../../hooks/use-loadmore";

import classes from "./JustForYouWrap.module.css";

const JustForYouWrap = (props) => {
  const {
    isVisible,
    dataLoaded,
    loadMore: loadMoreHandlers,
  } = useLoadMore(48, props.productItems);

  // useEffect(() => {
  //   loadMore();
  // }, [loadMore]);

  // const [isVisible, setIsVisible] = useState(24);
  // const [dataLoaded, setDataLoaded] = useState(false);

  // const loadMore = () => {
  //   setIsVisible((previousState) => previousState + 24);
  //   if (isVisible >= productCxt.productItems.length) {
  //     setDataLoaded(true);
  //   }
  // };

  return (
    <Fragment>
      <div
        className={
          props.customStyle
            ? classes["modal_row_cointainer"]
            : classes["row_cointainer"]
        }
      >
        {props.productItems.slice(0, isVisible).map((product) => {
          return (
            <ProductCard
            catId={product.categoryId}
              // key={product.id}
              // prodId={product.id}
              // prodThumbnail={product.thumbnail}
              // prodTitle={product.title}
              // prodPrice={product.price}
              // prodDiscountPct={product.discountPercentage}
              // prodRating={product.rating}
              key={product.productId}
              prodId={product.productId}
              prodThumbnail={product.thumbnail}
              prodTitle={product.title}
              prodPrice={product.price}
              prodOldPrice={product.old_price}
              prodDiscountPct={product.discount_in_percent}
              prodRating={product.productRating}
            />
          );
        })}
      </div>
      {!dataLoaded && (
        <div className={classes.card_loadMoreButton}>
          <OutlineButton
            className={classes.loadMoreButton}
            type="button"
            onClick={loadMoreHandlers}
          >
            load More
          </OutlineButton>
        </div>
      )}
    </Fragment>
  );
};

export default JustForYouWrap;
